<template>
  <div class="property-search col-centered">
    <form
      @submit.prevent="submit"
      method="PUT"
      accept-charset="UTF-8"
      novalidate="novalidate"
    >
      <div class="row">
        <div class="col-md-9 form-group">
          <b-form-input
            v-model="projectSelect"
            placeholder="Search Here"
            list="search-data"
          ></b-form-input>

          <datalist id="search-data">
            <option
              v-for="project in projects"
              :key="project.name"
              :value="project.name"
              >{{ project.name }}</option
            >
          </datalist>
        </div>
        <div class="col-md-3 form-group pull-right">
          <button type="submit" class="btn btn-success btn-block">
            Go
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    projects: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      projectSelect: null,
    };
  },

  methods: {
    submit() {
      var projectSelect = this.projectSelect;
      var slugs = this.projects.filter(function(project) {
        return project.name == projectSelect;
      });

      window.location.href = "/" + slugs[0].slug;
    },
  },
};
</script>
